<template lang="pug">
div.container.px-4.mx-auto.text-center  
  p.font-bold.text-acn-green.text-xl.relative.z-20.mb-8 {{section.title}}
  //- pre {{loading}}
  transition(name='quick-fade', appear, mode='out-in') 
    //- div(v-if='item')
    div(:key='loadedItem.id', v-if='item')
      staggered-transition(:speed='150')
        div(v-for='(index) in 2' :class='partClass(index)' :data-index="index" :key='index' :style="styleObj(index)").fixed.inset-0
      div.relative.z-20(v-show='!loading', v-images-loaded.on='callback')
        div.w-64.mx-auto
          img(v-if='item.image && item.image.length' :src='item.image[0].url' onload)
        h1.text-4xl {{item.title}}
        div(v-for='(part,index) of parts')
          div(v-in-viewport).max-w-xl.mx-auto.my-16.z-20
            img(v-if='part.image' :src='part.image.url').mx-auto.w-64
            p.font-bold.mb-4  {{part.title}}
            p.mb-4.text-xl.font-light(v-dompurify-html="part.text")
            
            p(v-for='link of part.links').font-bold.underline
              a(:href='link.url' target='_blank').hover_text-acn-green {{link.text}}

      
        p(v-dompurify-html="item.explanation").text-acn-green.text-sm.font-light.text-center

        div.text-acn-green.text-2xl.font-extrabold.my-8 
          p Wat denk je? Eventuele suggesties?
          p
            a(@click='feedbackMail(`Feedback op Act Circular Now: ${item.title}`)').underline.hover_text-acn-green-dark Geef je feedback!
        
        div.flex.my-8(v-if='prevItem && nextItem')
          router-link(class='w-1/2' :to="{name:'item', params:{sectionHandle, slug:prevItem.slug}}").border-r.border-acn-green.text-left.hover_text-acn-green
            p.text-sm Vorige
            p.text-2xl.font-light {{prevItem.title}}

          router-link(class='w-1/2' :to="{name:'item', params:{sectionHandle, slug:nextItem.slug}}").text-right.hover_text-acn-green
            p.text-sm Volgende
            p.text-2xl.font-light {{nextItem.title}}
</template>

<script>
import gql from 'graphql-tag'
import { apiQL } from '@/api'
import share from '@/mixins/share'
import { mapState } from 'vuex'
import { throttle } from 'lodash'
import imagesLoaded from 'vue-images-loaded'

export default {
  name: 'Item',
  directives: {
    imagesLoaded,
  },
  mixins: [share],
  props: {
    sectionHandle: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      scrollPos: window.scrollY,
      error: null,
      item: null,
      loadedItem: {},
    }
  },
  computed: {
    ...mapState({
      loading: 'loading',
      items(state) {
        return state[this.sectionHandle]
      },
    }),
    section() {
      return this.$store.getters.sections.find(
        (section) => section.handle === this.sectionHandle
      )
    },
    currentIndex() {
      if (!this.item) return -1
      return this.items.findIndex((item) => item.id === this.item.id)
    },
    nextItem() {
      if (this.currentIndex === -1) return null
      if (this.currentIndex === this.items.length - 1) return this.items[0]
      return this.items[this.currentIndex + 1]
    },
    prevItem() {
      if (this.currentIndex === -1) return null
      if (this.currentIndex === 0) return this.items[this.items.length - 1]
      return this.items[this.currentIndex - 1]
    },
    parts(item, string) {
      if (!this.item) return []
      const ding = {
        max: 'Het beste is om...',
        high: 'Je kan ook...',
        med: 'Je kan ook...',
        min: 'Je kan ook...',
      }
      const sections = []
      for (const [key, title] of Object.entries(ding)) {
        if (this.item[`${key}Text`]) {
          sections.push({
            title,
            text: this.item[`${key}Text`],
            links: (this.item[`${key}Links`] || []).map((link) => {
              try {
                const url = new URL(link.url)
                return {
                  text: url.hostname,
                  url: link.url,
                }
              } catch (error) {
                return {
                  text: link.url,
                }
              }
            }),
            image:
              this.item[`${key}Image`] && this.item[`${key}Image`].length
                ? this.item[`${key}Image`][0]
                : null,
          })
        }
      }
      return sections
    },
  },
  watch: {
    slug(newSlug) {
      this.loadItem(newSlug)
    },
  },
  // beforeCreate() {},
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  created() {
    this.$store.commit('loading', true)
    window.addEventListener('scroll', this.onScroll)
    this.loadItem()
  },
  mounted() {
    document.body.className = 'bg-acn-green-middle'
  },
  methods: {
    styleObj(index) {
      // const calc =
      // (0.5 - this.scrollPos) * (index * 0.75 * -45) - index * 0.75 * 15
      const calc = index * -15
      const origin = (1 - this.scrollPos) * (100 + 55 * index) + '%'
      return {
        'transition-duration': '100ms',
        'transform-origin': origin,
        'transition-timing-function': 'ease-in-out',
        transform: `skewY(${calc}deg)`,
      }
    },
    onScroll: throttle(
      function () {
        this.scrollPos = window.scrollY / document.body.scrollHeight
      },
      100,
      { leading: false }
    ),
    partClass(index) {
      const colors = [
        'bg-acn-green-middle',
        'bg-acn-green-light',
        'bg-acn-green-lighter',
      ]
      return [colors[index]]
    },
    callback(instance, img) {
      console.log('cb')

      this.loadedItem = this.item
      this.$store.commit('loading', false)
    },
    async loadItem() {
      this.$store.commit('loading', true)

      const fragment = `${this.sectionHandle}_${this.sectionHandle}`

      try {
        const q = gql`
          query ($type:[String] $name: [String!]) {
            entries(type:$type slug: $name) {
              id
              slug
              title
              sectionHandle
                ... on ${fragment}_Entry{
                  explanation
                  image{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
                  maxImage{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
                  maxText
                  maxLinks{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }

                  highImage{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
                  highText
                  highLinks{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }

                  medImage{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
                  medText
                  medLinks{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }

                  minImage{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
                  minText
                  minLinks{
                    url @transform(width: 400, mode: "fit", immediately: true)
                  }
              }
            }
          }
        `
        const result = await apiQL(q, {
          name: this.slug,
          type: this.sectionHandle,
        })

        const item = result.data.entries[0]
        this.item = item
      } catch (error) {
        console.warn(error)
        this.error = error
      }
      console.log(this.item)

      if (
        this.item &&
        (this.item.image.length ||
          this.item.maxImage.length ||
          this.item.medImage.length ||
          this.item.minImage.length)
      ) {
        this.loadedItem = {}
        this.$store.commit('loading', true)
      } else {
        this.loadedItem = this.item
        this.$store.commit('loading', false)
      }
    },
  },
  metaInfo() {
    const title = this.item ? this.item.title : null
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title,
      meta: [
        {
          vmid: 'og:title',
          content: title,
        },
      ],
    }
  },
}
</script>
